var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"e-offcanvas__nav e-offcanvas__nav--account"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{ name: 'index' }},domProps:{"innerHTML":_vm._s(_vm.$sanitize(_vm.backText))}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }